import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { LoadingComponent } from './loading.component';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { LoadingService } from './services/loading.service';

export function initializeService(appConfig: LoadingService) {
	// initialize app by loading components config
	return () => {};
}

@NgModule({
	imports: [LoadingComponent],
	exports: [LoadingComponent]
})
export class NgxLoadingModule {
	static forRoot(): ModuleWithProviders<NgxLoadingModule> {
		return {
			ngModule: NgxLoadingModule,
			providers: [
				{
					// components config initializer
					provide: APP_INITIALIZER,
					useFactory: initializeService,
					deps: [LoadingService],
					multi: true
				},
				{
					provide: HTTP_INTERCEPTORS,
					useClass: LoadingInterceptor,
					multi: true
				}
			]
		};
	}
}
